<template>
  <pt-points-reward class="pt-points-reward__withData" @rewardAudit="rewardAudit" @batchReview="batchReview" :isReview="isReview"
  :statisticsData="statisticsData" @closeDialog='closeDialog' ref="table" @pointsRewardExport="pointsRewardExport"></pt-points-reward>
</template>

<script>
import PtPointsReward from './index'
export default {
  name: 'pt-points-reward__withData',
  components: {
    'pt-points-reward': PtPointsReward
  },
  data () {
    return {
      isReview: false,
      statisticsData: {},
      loading: false,
      exportLoading: false
    }
  },
  methods: {
    pointsRewardExport (data) {
      this.exportLoading = true
      this.$store.dispatch('pointsRewardExport', data).then(res => {
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
        this.exportLoading = false
      }).catch(err => {
        this.$message.error(err || '导出提现记录失败')
        this.exportLoading = false
      })
    },
    rewardAudit (ids) {
      this.isReview = true
    },
    batchReview (ids, auditStatus) {
      if (auditStatus === 'SALES_COMPLETED') {
        this.rewardStatistics(ids)
      } else {
        this.batchrewardStatisticsSaler(ids)
      }
    },
    rewardStatistics (ids) {
      this.loading = true
      this.$store.dispatch('batchrewardStatistics', ids).then(res => {
        this.loading = false
        this.statisticsData = res
        if (!res.popupMessage) {
          this.isReview = true
        } else {
          this.$confirm('您选择的' + res.selectedRecordTotal + '条奖励记录中，有' + res.approvedTotal + '条已做过财务审核处理（已完成/已驳回），将对待审核状态的' +
           res.canApprovalTotal + '个用户进行批量审核', '批量发放提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            if (res.canApprovalTotal > 0) {
              this.isReview = true
            } else {
              this.$refs.table.clearSelection()
            }
          }).catch(_ => {
            this.$refs.table.clearSelection()
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '统计人数失败')
      })
    },
    batchrewardStatisticsSaler (ids) {
      this.loading = true
      this.$store.dispatch('batchrewardStatisticsSaler', ids).then(res => {
        this.loading = false
        this.statisticsData = res
        if (!res.popupMessage) {
          this.isReview = true
        } else {
          this.$confirm('您选择的' + res.selectedRecordTotal + '条积分记录中，有' + res.approvedTotal + '条已做过客服审核处理（已完成/已驳回），将对待审核状态的' +
           res.canApprovalTotal + '个用户进行批量审核', '批量发放提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning' }).then(_ => {
            if (res.canApprovalTotal > 0) {
              this.isReview = true
            } else {
              this.$refs.table.clearSelection()
            }
          }).catch(_ => {
            this.$refs.table.clearSelection()
          })
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '统计人数失败')
      })
    },
    closeDialog () {
      this.isReview = false
    }
  }
}
</script>
